/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { Link, Image } from '@ta-interaktiv/contentbricks'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  // Similar to componentDidMount and componentDidUpdate:

  const params = new URL(window.location).searchParams
  const type = params.get('type')

  if (type === 'juni') {
    return (
      <div className='index ta text'>
        <div className='column'>
          <div className='row'>
            <p>200</p>
            <p>Black Hawks</p>
          </div>
        </div>
        <div className='column'>
          <Image
            file={require('../../images/test.svg')}
            className='cbImage icon'
          />
        </div>
      </div>
    )
  }
  if (type === 'fahrzeuge') {
    return (
      <div className='index ta text'>
        <h4 className='graphicTitle'>
          Diese Fahrzeuge haben die USA 2003–2016 an die afghanischen
          Streitkräfte geliefert
        </h4>
        {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <span className='bigNumber'>42'604</span>
            </div>
            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-1.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Pick-up-Trucks und SUVs</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>22'174</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-2.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Humvees: geländegängige, gepanzerte Jeeps</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>8998</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-3.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Lastwagen</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>634</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-4.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>M1117: Truppentransportpanzer</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>189</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-5.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>M113 und M577: Truppentransportpanzer</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>155</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/fahrzeuge-6.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Maxx Pro: minensichere, gepanzerte Kampffahrzeuge</p>
          </div>
        </div>
        <div className='footer'>
          {' '}
          <div className='source'>
            Grafik: pvo; Quelle: US-Rechnungshof, The Times
          </div>
        </div>
      </div>
    )
  }
  if (type === 'waffen') {
    return (
      <div className='index ta text'>
        <h4 className='graphicTitle'>
          Diese Waffen haben die USA 2004–2016 an die afghanischen Streitkräfte
          geliefert
        </h4>
        {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>358'530</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/waffe-1.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Sturm- und Scharfschützen&shy;gewehre</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>126'295</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/waffe-2.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Pistolen</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>64'363</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/waffe-3.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Maschinengewehre</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>2606</div>
            </div>

            <div className='column image'>
              <Image
                file={require('../../images/waffe-4.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Mörser und Artilleriegeschütze</p>
          </div>
        </div>
        <div className='footer'>
          <div className='hint'>
            Hinweis: Zusätzlich wurden 25'327 Granatwerfer, 12'692 Shotguns und
            9877 Raketenwerfer geliefert.
          </div>
          <div className='source'>Grafik: pvo; Quelle: US-Rechnungshof</div>
        </div>
      </div>
    )
  }
  if (type === 'luftwaffe') {
    return (
      <div className='index ta text'>
        <h4 className='graphicTitle'>
          Diese Helikopter und Flugzeuge waren im Juni 2021 noch im Einsatz der
          afghanischen Armee
        </h4>
        {/* <div className='graphicSub'>
              <div>Durchmesser in Zentimeter</div>
            </div> */}
        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>43</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/helikopter-1.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>MD-530: leichte militärische Nutzhubschrauber</p>
          </div>
        </div>
        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>33</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/helikopter-2.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>UH-60 Blackhawks: Kampfhubschrauber</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <span className='bigNumber'>32</span>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/helikopter-3.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Mi-17: Transporthubschrauber</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>23</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/flugzeug-1.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            {' '}
            <p>A-29 Super Tucano: leichte Kampflugzeuge</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>23</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/flugzeug-2.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Cessna 208: leichte Passagier- und Frachtflugzeuge</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>10</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/flugzeug-3.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>Cessna AC-208: leichte Kampflugzeuge</p>
          </div>
        </div>

        <div className='contentWrapper'>
          <div className='row'>
            <div className='column'>
              <div className='bigNumber'>3</div>
            </div>

            <div className='column image luftwaffe'>
              <Image
                file={require('../../images/flugzeug-4.svg')}
                className='cbImage icon'
              />
            </div>
          </div>
          <div className='row byline'>
            <p>C-130: grosse Transportflugzeuge</p>
          </div>
        </div>
        <div className='footer'>
          {' '}
          <div className='source'>
            Grafik: pvo; Quelle: Aufsichtsbehörde der US-Regierung für den
            Wiederaufbau Afghanistans
          </div>
        </div>
      </div>
    )
  }
  return false
}
